import loadable from '@loadable/component';
import { Suspense } from 'react';

import { configs } from '../configs/configs';

export const withMerchantComponents = ({ Component, fileName, atomicFolderName }) => {
  try {
    const Module = loadable(
      props =>
        import(
          /* webpackPrefetch: true */ `@hero/merchants/${props.merchantName}/components/${props.atomicFolderName}`
        ).catch(() => ({
          [props.fileName]: Component
        })),
      {
        cacheKey: props => props.fileName,
        resolveComponent: (components, props) => {
          return components[props.fileName];
        }
      }
    );

    const LoadableComponent = props => (
      // TODO: change fallback
      <Suspense fallback={<div>Loading...</div>}>
        <Module
          {...props}
          merchantName={configs.merchantName}
          atomicFolderName={atomicFolderName}
          fileName={fileName}
        />
      </Suspense>
    );

    return LoadableComponent;
  } catch {
    return Component;
  }
};

export const withMerchantFunction =
  ({ defaultFunction, fileName, folderPath }) =>
  async () => {
    const merchantName = configs.merchantName;

    try {
      const files = await import(
        /* webpackPrefetch: true */
        `../merchants/${merchantName}/${folderPath}`
      );

      return files[fileName] || defaultFunction;
    } catch {
      return defaultFunction;
    }
  };
